import { FormOutlined } from '@ant-design/icons';
import { Input, InputProps, Space, Spin, Typography } from 'antd';
import Button from 'antd/es/button';
import React, { useState, useRef, useEffect } from 'react';

const { Paragraph } = Typography;
export interface InlineEditorProps extends Omit<InputProps, 'onSubmit'> {
  value: string;
  onSubmit?: (value: string) => Promise<any>;
  clickCb?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

const InlineEditor = (props: InlineEditorProps) => {
  const { value: valueProp, onSubmit, clickCb, ...otherProps } = props;
  const [editing, setEditing] = useState(false);
  const valuePropRef = useRef(valueProp);
  const [submitting, setSubmitting] = useState(false);

  const [value, setValue] = useState(valueProp);
  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  const showInput = submitting || editing;
  const doSubmit = async () => {
    if (onSubmit) {
      setSubmitting(true);
      try {
        const result = await onSubmit(value);
        if (result === false) {
          setValue(valuePropRef.current);
        } else {
          setEditing(false);
          valuePropRef.current = value;
        }
      } catch (e) {
        //
      }
      setSubmitting(false);
    }
  };
  return showInput ? (
    <Spin spinning={submitting}>
      <Input
        style={{ width: 160 }}
        autoFocus
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onBlur={doSubmit}
        onPressEnter={doSubmit}
        value={value}
        {...otherProps}
      />
    </Spin>
  ) : (
    <Space>
      <Paragraph style={{ width: 160 }} ellipsis={{ rows: 2, tooltip: value }}>
        {value || '-'}
      </Paragraph>
      <Button
        onClick={(e) => {
          setEditing(true);
          if (clickCb) {
            clickCb(e);
          }
        }}
        type="link"
        style={{ color: '#84868C' }}
      >
        <FormOutlined />
      </Button>
    </Space>
  );
};
export default React.memo(InlineEditor);
